import { Base } from "../base";

export class TradingPlaceType extends Base{
  
}